module.exports = __webpack_public_path__ + "img/head2.8f7cf683.png";